import { useSelector } from 'react-redux'
import { selectRoutes } from '@/features/domain/route'

export const useHasRoutePaths = () => {
  const routePaths = useSelector(selectRoutes)

  return Object.keys(routePaths).length > 0
}
